import { jsonParseLinter } from '@codemirror/lang-json';
import { syntaxTree } from '@codemirror/language';
import { Diagnostic, linter } from '@codemirror/lint';
import { EditorView } from '@codemirror/view';
import { SyntaxNode } from '@lezer/common';

function customJsonLinter(view: EditorView): Diagnostic[] {
  const languageDiagnostics = jsonParseLinter()(view);
  const propertiesByObject = new Map<SyntaxNode, string[]>();
  const customDiagnostics: Diagnostic[] = [];

  try {
    syntaxTree(view.state)
      .cursor()
      .iterate(({ node }) => {
        if (node.name === 'PropertyName') {
          const parentObject = node.parent?.parent as SyntaxNode;
          const propertyName = view.state.sliceDoc(node.from, node.to);

          if (propertiesByObject.has(parentObject)) {
            const properties = propertiesByObject.get(parentObject) || [];
            if (properties.includes(propertyName)) {
              customDiagnostics.push({
                from: node.from,
                to: node.to,
                severity: 'error',
                message: `Duplicated property ${propertyName}`
              });
            }
          }

          propertiesByObject.set(parentObject, [
            ...(propertiesByObject.get(parentObject) || []),
            propertyName
          ]);
        }
      });
  } catch (error) {
    customDiagnostics.push({
      from: 0,
      to: view.state.doc.length,
      severity: 'error',
      message: 'Invalid JSON syntax'
    });
  }

  return languageDiagnostics.concat(customDiagnostics);
}

export const jsonLinter = linter(customJsonLinter);
